import dayjs from 'dayjs';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import utc from 'dayjs/plugin/utc';

dayjs.extend(isSameOrBefore);
dayjs.extend(utc);

export default {
  validate(value) {
    return dayjs.utc(value).isSameOrBefore(dayjs().utc(), 'days');
  },
};
